<template>
  <div class="home">
    <b-container fluid>
      <div class="d-flex justify-content-center mt-4 mr-4 ml-4">
        <img class="logo-oem" alt="OMEGA EUROPEAN MASTERS" src="../assets/img/logo-2019.svg">
      </div>
      <h4 class="text-center mt-4 mb-0">{{ $t('title') }}</h4>
      <div class="text-center mb-2">
        {{ $t('access_control') }}
      </div>
      <div class="d-flex flex-column align-items-center">
        <form class="oem-camera-form">
          <div v-if="error" class="mb-4 text-center text-danger">{{ error }}</div>
          <qrcode-stream class="text-center" @decode="onDecode" @init="onInit" v-if="camera">
            <b-spinner class="loading-indicator" label="Loading..." v-if="loading"></b-spinner>
          </qrcode-stream>
          <div class="oem-scan-buttons">
            <b-button class="oem-scan-button mt-4" block type="button"
                      v-on:click.prevent="onScan">COMMENCER LE SCAN
            </b-button>
            <b-button v-if="this.$store.getters.isLogged" class="oem-scan-button mt-4" block type="button"
                      v-on:click.prevent="onLogout">{{ $t('logout') }}
            </b-button>
          </div>
        </form>
      </div>
    </b-container>
  </div>
</template>

<script>
import BContainer from "bootstrap-vue/src/components/layout/container";
import axios from 'axios';

export default {
  name: 'scan',
  data: function () {
    return {
      title: this.$t('title'),
      error: null,
      result: null,
      loading: true,
      camera: false
    }
  },
  components: {
    BContainer
  },
  created() {
    //if (!this.$store.getters.isLogged)
    //  this.$router.push('./partners');
  },
  methods: {
    async onDecode(result) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      try {
        var response = '';
        if (this.$store.getters.username) {
          response = await axios.post('https://access-admin.omegaeuropeanmasters.com/en/scan/scan/' + result,
              // response = await axios.post('http://localhost:8000/en/scan/scan/' + result,
              {
                username: this.$store.getters.username
              },
              {
                headers: headers
              });
        } else
          response = await axios.post('https://access-admin.omegaeuropeanmasters.com/en/scan/scan/' + result);
        // response = await axios.post('http://localhost:8000/en/scan/scan/' + result);

        var card = response.data.card;
        this.$store.dispatch('updateCard', card);

        if (this.$store.getters.isLogged)
          this.$router.push('register');
        else
          this.$router.push('details');
      } catch (e) {
        this.error = this.$t('invalid_code');
      }
    },
    async onInit(promise) {
      try {
        await promise;
        this.loading = false
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$t('not_allowed_error')
        } else if (error.name === 'NotFoundError') {
          this.error = this.$t('not_found_error')
        } else if (error.name === 'NotSupportedError') {
          this.error = this.$t('not_supported_error')
        } else if (error.name === 'NotReadableError') {
          this.error = this.$t('not_readable_error')
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$t('overconstrained_error')
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$t('not_supported_api_error')
        }
      }
    }, async onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('partners');
    }
    , turnCameraOn() {
      this.camera = 'on';
      // setTimeout(function () {
      //     this.camera = false
      // }.bind(this), 60000);
    }, async onScan() {
      this.turnCameraOn();
    }
  }
}
</script>
<style lang="scss">
.oem-camera-form {
  max-width: 500px;
  width: 100%;
  height: 320px;
}

.oem-scan-buttons {
  max-width: 300px;
  width: 100%;
  margin: auto;
}

.qrcode-stream {
  max-width: 500px !important;
  width: 100% !important;
  height: 320px !important;
}

.qrcode-stream__inner-wrapper {
  max-width: 500px !important;
  width: 100% !important;
  height: 320px !important;
}

.qrcode-stream__camera {
  max-width: 500px !important;
  width: 100% !important;
  height: 320px;
}

.loading-indicator {
  margin-top: 3.5em;
  color: #f8222c;
}

.language-switcher {
  margin-top: 50px;
}
</style>
